import type { SurveyWithConfigResponse } from '@coorum-research/shared-common/api-response/survey-with-config.schema'
import type { SurveyResponse } from '@coorum-research/shared-common/api-response/survey.schema'
import http from './http'

export const surveyApi = () => {
  /**
   * @deprecated - use getSurveyWithConfig
   */
  const getSurvey = async (surveyId: string) => {
    const response = await http.get<SurveyResponse>(`/surveys/${surveyId}`)
    return response.data
  }

  const getSurveyWithConfig = async (surveyId: string) => {
    const response = await http.get<SurveyWithConfigResponse>(`/surveys/${surveyId}/with-config`)
    return response.data
  }

  return {
    getSurvey,
    getSurveyWithConfig,
  }
}
